import { useState, useEffect } from "react";
import { MdOutlineMenu, MdClose } from "react-icons/md";
import { Link } from "react-router-dom";
import {
  FaHome,
  FaInfoCircle,
  FaBook,
  FaFileInvoiceDollar,
  FaBriefcase,
  FaUsers,
} from "react-icons/fa";
import logoImg from "../assets/images/logo-120x120.png";
import SearchForm from "./SearchForm";

export default function CoursesNavbar() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Menu links with Business Courses after About
  const menuLinks = [
    { text: "Home", to: "/training", icon: <FaHome color="#1E90FF" /> },
    { text: "About", to: "/training-about-us", icon: <FaInfoCircle color="#32CD32" /> },
    { text: "Business Courses", to: "/professional-business-courses", icon: <FaBriefcase color="#8A2BE2" /> },
    { text: "Accounting Training", to: "/Accounting-Course", icon: <FaBook color="#FFA500" /> },
    { text: "Taxation Training", to: "/professional-taxation-training", icon: <FaFileInvoiceDollar color="#FF4500" /> },
    { text: "Management Training", to: "/professional-management-training", icon: <FaUsers color="#FF1493" /> },
  ];

  return (
    <>
      <header
        style={{
          minHeight: "90px",
          padding: "15px 20px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          backgroundColor: "#fff",
          borderBottom: "1px solid #ddd",
          zIndex: 999,
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
        }}
      >
        {/* Logo */}
        <div
          style={{
            flex: "0 0 auto",
            marginLeft: isMobile ? "0px" : "55px",
          }}
        >
          <Link to="/" className="logo" style={{ display: "flex", alignItems: "center" }}>
            <img src={logoImg} width="75px" height="75px" alt="logo" />
          </Link>
        </div>

        {/* Mobile: Search bar slightly right and higher */}
        {isMobile && (
          <div
            style={{
              flex: "1 1 auto",
              display: "flex",
              justifyContent: "center",
              position: "relative",
              left: "15px",
              transform: "translateY(-15px)",
            }}
          >
            <div style={{ width: "100%", maxWidth: "250px" }}>
              <SearchForm />
            </div>
          </div>
        )}

        {/* Mobile: Menu icon */}
        {isMobile && (
          <div style={{ flex: "0 0 auto" }} onClick={() => setMenuOpen(!menuOpen)}>
            {menuOpen ? (
              <MdClose style={{ fontSize: "40px", cursor: "pointer" }} />
            ) : (
              <MdOutlineMenu style={{ fontSize: "40px", cursor: "pointer" }} />
            )}
          </div>
        )}

        {/* Desktop: Nav menu + search */}
        {!isMobile && (
          <>
            <nav style={{ flex: "1 1 auto", display: "flex", justifyContent: "center" }}>
              <ul
                style={{
                  listStyle: "none",
                  display: "flex",
                  gap: "25px",
                  margin: 0,
                  padding: 0,
                }}
              >
                {menuLinks.map((link, idx) => (
                  <li key={idx}>
                    <Link
                      to={link.to}
                      style={{
                        textDecoration: "none",
                        color: "#333",
                        fontWeight: 500,
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      {link.icon}
                      {link.text}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>

            <div
              style={{
                flex: "0 0 auto",
                marginRight: "55px",
                transform: "translateY(-10px)",
              }}
            >
              <SearchForm />
            </div>
          </>
        )}
      </header>

      {/* Mobile dropdown menu */}
      {isMobile && menuOpen && (
        <nav
          style={{
            position: "fixed",
            top: "100px",
            left: 0,
            width: "100%",
            height: "calc(100vh - 100px)",
            backgroundColor: "#fff",
            zIndex: 998,
            padding: "20px",
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            overflowY: "auto",
          }}
        >
          {menuLinks.map((link, idx) => (
            <Link
              key={idx}
              to={link.to}
              onClick={() => setMenuOpen(false)}
              style={{
                textDecoration: "none",
                color: "#333",
                fontWeight: 500,
                fontSize: "18px",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              {link.icon}
              {link.text}
            </Link>
          ))}
        </nav>
      )}

      {/* Spacer for fixed header */}
      <div style={{ height: "90px" }}></div>
    </>
  );
}
